<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light" class="mt-3">
                <b-row v-if="statusId === StatusEnum.PROCESSO_COMPRA_EM_ANDAMENTO.value">
                    <b-col cols="11"></b-col>
                    <b-col>
                        <b-button id="novoConsultarAutorizacaoFornecimentoForm" class="mr-2 my-2" size="sm"
                            style="height: 20px" pill @click="clickMostrarModalForm" variant="primary">
                            <div class="btn-size-alinhamento">
                                <b-icon scale="1" icon="plus" />
                            </div>
                            <b-tooltip target="novoConsultarAutorizacaoFornecimentoForm" title="Adicionar novo..."
                                triggers="hover"></b-tooltip>
                        </b-button>
                    </b-col>
                </b-row>
                <b-table responsive class="mt-2" small show-empty :busy="busy" :items="records" :fields="fields" hover>
                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>
                    <template v-slot:cell(dataCriacao)="data">
                        <span v-if="data.item.dataCriacao">
                            {{ formatDate(data.item.dataCriacao) }}
                        </span>
                        <span v-else>
                            N/A
                        </span>
                    </template>
                    <template v-slot:cell(actions)="data">
                        <b-button v-if="statusId === StatusEnum.PROCESSO_COMPRA_EM_ANDAMENTO.value || statusId === StatusEnum.PROCESSO_COMPRA_APROVADO.value"
                            v-b-tooltip.hover.top="'Registro de Entrada'" class="my-2 mx-1" size="sm" pill
                            variant="primary" @click="abrirRegistroEntradaForm(data.item.totalItens != data.item.totalItensEntrada, data.item)">
                            <b-icon icon="file-earmark-plus" />
                        </b-button>

                        <b-button :id="data.index + 'visualizar-button'" class="my-2 mx-1" size="sm" pill
                            variant="primary" @click="visualizar(data.item)">
                            <b-icon icon="eye" />
                            <b-tooltip :target="data.index + 'visualizar-button'" title="Visualizar"></b-tooltip>
                        </b-button>
                    </template>
                </b-table>
                <b-row style="margin-top: 12px">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                                totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-card-body>
        <ConsultarAutorizacaoFornecimentoForm :autorizacaoFornecedorId="autorizacaoFornecedorId"
            :isViewMode="isViewMode" @close="fecharModalForm" :prefix="[prefix + title]" v-if="mostrarModalForm"
            :processoId="this.processoId">
        </ConsultarAutorizacaoFornecimentoForm>

        <ModalRegistroEntradaList :podeAdicionarRegistro="podeAdicionarRegistro" v-if="showModalRegistroEntradaList" :prefix="prefix + title"
            ref="modalRegistroEntradaForm" @close="fecharRegistroEntradaForm" :idAutorizacao='selectedAutorizacaoId' />
    </b-card>
</template>

<script>
import ResourceService from "@/core/api/ResourceService";
import { ListResourceMixin } from "@/core/mixins/resource";
import ConsultarAutorizacaoFornecimentoForm from "./ConsultarAutorizacaoFornecimentoForm.vue";
import StatusEnum from "@/core/utils/StatusEnum";
import ModalRegistroEntradaList from "@/modules/almoxarifados/registros-entrada/ModalRegistroEntradaList.vue";
export default {
    components: {
        ConsultarAutorizacaoFornecimentoForm,
        ModalRegistroEntradaList
    },
    mixins: [ListResourceMixin],

    props: {
        prefix: {

            type: String,
            default: ""
        },
        processoId: Number,
        status: {
            type: Number,
            default: null,
        },
        consultaDetalhada: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            podeAdicionarRegistro: true,
            showModalRegistroEntradaList: false,
            selectedAutorizacaoId: null,
            statusId: null,
            autorizacaoFornecedorId: null,
            isViewMode: false,
            StatusEnum: StatusEnum,
            autorizacaoSelecionada: {},
            mostrarModalForm: false,
            pesquisa: "",
            title: "Consultar Autorização de Fornecimento",
            fields: [
                { key: "numeroProcesso", label: "Nº Processo" },
                { key: "totalItens", label: "Total de Itens da Autorização" },
                { key: "totalItensEntrada", label: "Total Consumo" },
                { key: "banco", label: "Banco" },
                {
                    key: "dataprevisaoentrega", label: "Data de Previsão de Entrega",
                    formatter: (value) => value ? new Date(value).toLocaleDateString() : "-",

                },
                { key: "descricao", label: "Descrição" },
                { key: "actions", label: "" },
            ],
            currentPage: 1,
            perPage: 10,
            totalPages: 1,
            busy: false,
            perPageOptions: [5, 10, 25, 50],
        }
    },
    watch: {
        page() {
            this.load()
        },
    },
    beforeMount() {
        this.$service = new ResourceService(`/api/autorizacaofornecedor/buscar-filtro`);
        this.$serviceProcesso = new ResourceService(`/api/processocompra/status`)

        this.load()
    },
    methods: {
        abrirRegistroEntradaForm(podeAdicionarRegistro, autorizacao) {
            this.podeAdicionarRegistro = podeAdicionarRegistro;
            this.selectedAutorizacaoId = autorizacao.cod;
            this.showModalRegistroEntradaList = true;

        },
        fecharRegistroEntradaForm() {
            this.podeAdicionarRegistro = true;
            this.showModalRegistroEntradaList = false;
            this.selectedAutorizacaoId = null
            this.load();
        },

        async load() {
            this.busy = true
            this.filtro = {};

            this.filtro.processo = this.processoId;
            var { data } = await this.$serviceProcesso.get(this.processoId);
            this.statusId = data;

            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.filtro,

            });

        },
        visualizar(autorizacao) {

            this.autorizacaoFornecedorId = autorizacao.cod
            this.isViewMode = true;
            this.mostrarModalForm = true;

        },
        clickMostrarModalForm() {
            this.autorizacaoFornecedorId = null;
            this.isViewMode = false;
            this.mostrarModalForm = true;
        },
        fecharModalForm() {
            this.isViewMode = false;
            this.mostrarModalForm = false;
            this.load();
        }
    },
}
</script>

<style scoped>
.badge {
    font-size: 85% !important;
    padding: 5px 10px !important;
}

.btn-size-alinhamento {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
